const TEMPLATE_VARIABLE_REGEX = /{{\s*[^}]+\s*}}/g;

export function getBatchVariablesFromPropertyValue(
  propertyValue: { [key: string]: any }[] | string
): string {
  // we are strictly checking if propertyValue is null or defined,
  // there is no particular check for other types, since the desired data is either string or array of objects
  if (propertyValue === null || propertyValue === undefined) {
    return '';
  }

  const propertyString = Array.isArray(propertyValue)
    ? JSON.stringify(propertyValue)
    : propertyValue;

  const matches = propertyString.match(TEMPLATE_VARIABLE_REGEX);

  return matches ? matches.join(' ') : propertyString;
}
